export const createMandate = (payload) => {
    return ApiClient.post('/account/e-invoicing/mandate', {}, payload);
};
